<template>
  <v-container class="py-0">
    <IntroText
      :intro-one="pageItem.MainText"
      :pageItem="pageItem"
    />
    <v-row v-if="events && EventItem.length !== 0">
      <v-col v-for="item in EventItem" :key="item.Code" cols="12" sm="6">
        <NuxtLink class="text-decoration-none" v-if="item.Code && item.NameUrl" :to="{
          path: $methods.pageUrlByPageType('DE') + '/' + item.NameUrl,
        }">
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="3" xl="2" class="pt-0">
              <NVEAROverviewImg :item="item"/>
            </v-col>
            <v-col cols="8" sm="8" md="8" lg="9" xl="10" class="pt-0">
              <h2 class="pt-0">
                {{ item.Title }}
              </h2>
              <p class="pt-2 pb-0">{{ item.EventOrganisationName }} - {{ item.LocationName }} - {{ item.StandNumber }}</p>
              <p class="text-lighttext pb-1" v-if="item.MainText">
                <span v-html="$helpers.stripHtml(item.MainText, 90)"></span>
              </p>
              <p class="pt-0" v-if="item.EventDateTime?.length">
                {{ item.EventDateTime[0].Date }} / {{ item.EventDateTime[item.EventDateTime.length - 1].Date }}
              </p>
            </v-col>
          </v-row>
        </NuxtLink>
      </v-col>
    </v-row>

    <PaginationUrl :total="events?.length || 0" :per-page="perPage" />
  </v-container>
</template>

<script setup>
import IntroText from "@/components/Base/introText.vue";
import PaginationUrl from "@/components/Base/PaginationUrl.vue";
import NVEAROverviewImg from "@/components/Base/NVEAROverviewImg.vue";

const { $methods, $helpers } = useNuxtApp()
const eventOverview = useEventOverviewStore();
const events = computed(() => eventOverview.EventItems)

const perPage = 4;

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});


const { currentPage } = await usePageQuery(events?.length, perPage);

const EventItem = computed(() => {
  const EventCopy = [...(events.value || [])];
  return EventCopy
    .reverse()
    .slice((currentPage.value - 1) * perPage, currentPage.value * perPage);
});

</script>